import type React from 'react';

import { CmsHtml } from 'src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { content, styles },
	} = usePageBody();

	return (
		<div className="container py-14">
			<CmsHtml html={content} styles={styles} />
		</div>
	);
};
